import React, { useState } from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import press1 from '../../images/press/press1.png';
import press2 from '../../images/press/press-2.png';
import SectionTitle from '../SectionTitle/SectionTitle';

const pressNews = [
    {
        id: '01',
        img: press1,
        title: 'Kadının Elinin Değdiği Her Yerde Fark Oluşur',
        summary: 'KYS Lojistik Yönetim Kurulu Başkanı Muhibe Kuyaş, kadın liderliğinin iş dünyasındaki etkisini ve lojistik sektöründeki dönüşümü anlattı.',
        source: 'Makina Market',
        link: 'https://makina-market.com.tr/kys-lojistik-yonetim-kurulu-baskani-muhibe-kuyas-kadinin-elinin-degdigi-her-yerde-fark-olusur/'
    },
    {
        id: '02',
        img: press2,
        title: 'KYS Lojistik Güçlü Altyapısıyla Beş Sektöre Entegre Hizmet Sunuyor',
        summary: 'KYS Lojistik, güçlü operasyonel altyapısı ve entegre hizmet modeliyle beş farklı sektöre kapsamlı çözümler sunuyor.',
        source: 'Makina Market',
        link: 'https://makina-market.com.tr/kys-lojistik-guclu-altyapisiyla-bes-sektore-entegre-hizmet-sunuyor/'
    }
];

const Testimonial = () => {

    const [nav1, setNav1] = useState();
    const [nav2, setNav2] = useState();

    return (
        <section className="wpo-testimonial-section section-padding">
            <div className="container">
                <div className="wpo-testimonial-wrap">
                    <div className="row">
                        <div className="col-lg-6">
                            <SectionTitle
                                subTitle={'BASINDA BİZ'}
                                Title={'Medyada Yer Alan Haberlerimiz'}
                            />
                            <div className="wpo-testimonial-items">
                                <Slider
                                    asNavFor={nav2}
                                    ref={(slider1) => setNav1(slider1)}
                                    dots={true}
                                    arrows={false}
                                >
                                    {
                                        pressNews.map((news, index) => (
                                            <div className="wpo-testimonial-item" key={index}>
                                                <div className="wpo-testimonial-text">
                                                    <h3>{news.title}</h3>
                                                    <p>{news.summary}</p>
                                                    <div className="wpo-testimonial-text-btm">
                                                        <span>{news.source}</span>
                                                        <h4>
                                                            <a
                                                                href={news.link}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Haberi Oku →
                                                            </a>
                                                        </h4>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    }
                                </Slider>
                            </div>
                        </div>

                        <div className="col-lg-5 offset-lg-1">
                            <div className="testimonial-right-side">
                                <Slider
                                    asNavFor={nav1}
                                    ref={(slider2) => setNav2(slider2)}
                                    slidesToShow={1}
                                    fade={true}
                                    swipeToSlide={true}
                                    focusOnSelect={true}
                                >
                                    {
                                        pressNews.map((news, index) => (
                                            <div className="testimonial-img" key={index}>
                                                <img src={news.img} alt={news.title} />
                                            </div>
                                        ))
                                    }
                                </Slider>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </section>
    );
}

export default Testimonial;